module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.redefine.js
// module id = 157
// module chunks = 0